import { writable } from 'svelte/store';
const store = {
    auth_user: undefined,
    user: undefined,
    company: undefined,
    charity: undefined,
    origin: undefined,
    temp_context: {}
};
export const appState = writable(store);
